<template>
  <v-container :style="{display: 'flex', height: '100%', 'justify-content': 'center', margin: '0 auto 0 auto'}" class="hideScroll">
    <v-card flat width="600" style="align-self: center; padding: 20px;">
      <div class="mb-4">
        <v-img class="mx-auto" height="150" width="150" src="@/assets/epesis.png"></v-img>
      </div>
      <v-card-title style="text-align: center; justify-content: center;">
        {{$t('loginflow.login_to_tiimi')}}
      </v-card-title>
      <v-form
        ref="form"
        @submit="submit"
        :lazy-validation="true"
      >
        <v-text-field
          label="Sähköpostiosoite"
          ref="username"
          autocomplete="username"
          type="email"
          v-model="form.email"
          placeholder="email"
          :rules="required"
        ></v-text-field>
        <v-text-field
          label="Salasana"
          ref="password"
          autocomplete="password"
          :type="passwordType ? 'text' : 'password'"
          :append-icon="passwordType ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="passwordType = !passwordType"
          placeholder="password"
          v-model="form.password"
          :rules="required"
        ></v-text-field>
        <div class="my-1" style="text-align: center;">
          <v-btn x-small text @click="$router.push('/forgot')">{{$t('loginflow.order_new')}}</v-btn>
          <v-btn x-small text @click="$router.push('/signin')">{{$t('loginflow.signin_here')}}</v-btn>
        </div>
        <v-card-actions style="justify-content: center;">
          <v-btn rounded class="mt-2" :loading="loading" type="submit" color="primary">
            {{$t('login')}}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    form: {
      email: '',
      password: ''
    },
    passwordType: false,
    loading: false,
    email: '',
    required: [
      v => !!v || 'Required',
    ]
  }),
  methods: {
    ...mapActions({
      login: 'auth/login',
      error: 'noti/error'
    }),
    ...mapActions('user', [
      'initUser'
    ]),
    submit(e) {
      e.preventDefault();

      const validated = this.$refs.form.validate()
      if(!validated) return

      this.loading = true
      this.login(this.form)
        .then(res => {
          this.initUser(res.data.token)
          console.log('res', res.data)
          if(this.$route.query.invite_code) {
            this.$router.push({ path: '/team/join', query: this.$route.query })
          } else if(this.$route.query.ref) {
            this.$router.push(this.$route.query.ref)
          } else {
            this.$router.push('/')
          }

          this.track('Login')
        })
        .catch(err => {
          this.error(err)
          this.track('Login error', {
            error: JSON.stringify(err)
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>